import React from 'react';
import { View, StyleSheet } from 'react-native';
import { CommonProperties } from '../../../styles';

const ExpandableContent = ({ style, ...rest }) => {
  return <View style={[styles.container, style]} {...rest} />;
};

const styles = StyleSheet.create({
  container: {
    ...CommonProperties.py4,
    ...CommonProperties.mx3,
    ...CommonProperties.px3,
    textAlign: 'justify',
  },
});

export default ExpandableContent;
